import {
  ImageZnglistClassicTemplate,
  ImageZnglistPersonalizedTemplate,
  ImageZnglistPlaceHolder,
} from '@/assets/images';
import { PostStatusEnum, ZnglistTemplateTypeEnum } from '@/graphql/types';
import { useEffect } from 'react';
import { useEditZnglistStore } from '../editZnglistStore';

export const ZnglistTemplateInfoOptions = {
  [ZnglistTemplateTypeEnum.Classic]: {
    type: ZnglistTemplateTypeEnum.Classic,
    prettyType: 'Company',
    title: 'Company Znglist',
    description: 'A Company Znglist',
    image: ImageZnglistClassicTemplate,
    rules: null,
  },
  [ZnglistTemplateTypeEnum.Personal]: {
    type: ZnglistTemplateTypeEnum.Personal,
    prettyType: 'Personal',
    title: 'Personalised Znglist',
    description: 'A Znglist that is personalised to the user. Uses your bio to create a znglist with a personal touch.',
    image: ImageZnglistPersonalizedTemplate,
    rules: {
      status: {
        exclude: [PostStatusEnum.Publish],
      },
    },
  },
};

export const getZnglistTemplateInfo = (
  key: string | ZnglistTemplateTypeEnum | null | undefined
): {
  type: ZnglistTemplateTypeEnum;
  prettyType: string;
  title: string;
  description: string;
  image: string;
  rules: {
    status?: {
      exclude?: PostStatusEnum[];
    };
  } | null;
} => {
  switch (key?.toLowerCase?.()) {
    case 'classic':
      return ZnglistTemplateInfoOptions[ZnglistTemplateTypeEnum.Classic];
    case 'personal':
      return ZnglistTemplateInfoOptions[ZnglistTemplateTypeEnum.Personal];
    default:
      return {
        type: ZnglistTemplateTypeEnum.Pending,
        prettyType: 'Unknown',
        title: 'Unknown Znglist',
        description: 'An unknown Znglist',
        image: ImageZnglistPlaceHolder,
        rules: null,
      };
  }
};

const DefaultSelectTemplate = () => {
  const templateType = useEditZnglistStore((store) => store?.znglist?.templateType);

  useEffect(() => {
    if (getZnglistTemplateInfo(templateType)?.type === ZnglistTemplateTypeEnum.Pending) {
      useEditZnglistStore.setState((prev) => ({
        ...prev,
        znglist: {
          ...prev.znglist,
          templateType: ZnglistTemplateTypeEnum.Personal,
        },
      }));

      useEditZnglistStore.temporal.getState().clear();
    }
  }, [templateType]);

  return null;
};

export default DefaultSelectTemplate;
